import { OUTLOOK_LG_INTRO, OUTLOOK_LG_SLUG } from '@/content/outlookLogistics'
import { outlook } from '@/content/reportBuilder'
import type { Report } from '@/content/reportBuilder'

export const report: Report = {
  // The eighteenth report with a designed page of its own, and the ninth Future
  // 2030 outlook — asked for on 2026-08-28 in the same words as the eight before it
  // (*"referans alarak ilgili sayfayı birebir tıpa tıp aynısını tasarla"*) with a
  // four-part full-page capture of the live page and all six of the images it
  // carries. See `content/outlookLogistics.ts` and `pages/OutlookLogistics.tsx`.
  ...outlook(
    OUTLOOK_LG_SLUG,
    'Logistics',
    undefined,
    'future-2030-outlook-logistics-cover',
    'edbf74eb-db0f-41f8-8cd0-397b71045ebe-Digitopia-Digital-Transformation-Outlook-Logistics.pdf',
  ),
  // The hero's bold claim and the first of its two paragraphs — same as the sibling
  // outlook entries, and for the same reason: this page draws its hero from
  // `OUTLOOK_LG_INTRO` directly, so `body` feeds exactly one thing, the meta
  // description `prerender.tsx` takes from `body[0]`. The claim carries no full stop
  // on the live page, so one is supplied here rather than running the two sentences
  // together in a search result.
  body: [`${OUTLOOK_LG_INTRO.lede}. ${OUTLOOK_LG_INTRO.body[0]}`],
  layout: 'logistics-outlook',
  // Its own words, its cover, its file and the six images its bands draw, so
  // `stillToCome` has nothing left to say about it. What is still open is
  // section-by-section on its page, and `outlookLogisticsChecks()` carries that into
  // the manifest.
  check: undefined,
}

/** Its place in the index grid — the order the imported page listed them. */
export const order = 23
